import React, { useState } from "react";
import { playClaimSound, playCloseSound } from "../../Sounds";

// ─── MISSION DEFINITIONS ──────────────────────────────────────
export const MISSION_POOL = [
  { id: "roll_5",       emoji: "🎲", name: "Warm Up",        desc: "Roll 5 times",                  type: "rolls",        target: 5,   reward: 50,  difficulty: "easy"   },
  { id: "roll_10",      emoji: "🎲", name: "On a Roll",       desc: "Roll 10 times",                 type: "rolls",        target: 10,  reward: 80,  difficulty: "easy"   },
  { id: "spend_coins",  emoji: "🛒", name: "Shop Run",        desc: "Spend 100 coins in the shop",   type: "coinsSpent",   target: 100, reward: 60,  difficulty: "easy"   },
  { id: "get_uncommon", emoji: "💚", name: "Green Machine",   desc: "Pull an Uncommon or better",    type: "minRarity",    target: "Uncommon", reward: 40, difficulty: "easy" },
  { id: "roll_25",      emoji: "🎲", name: "Roll Grinder",    desc: "Roll 25 times today",           type: "rolls",        target: 25,  reward: 150, difficulty: "medium" },
  { id: "get_rare",     emoji: "💙", name: "Going Rare",      desc: "Pull a Rare or better",         type: "minRarity",    target: "Rare",   reward: 120, difficulty: "medium" },
  { id: "get_3_new",    emoji: "🗂️", name: "New Hamsters",    desc: "Add 3 new hamsters today",      type: "newHamsters",  target: 3,   reward: 200, difficulty: "medium" },
  { id: "spend_300",    emoji: "💰", name: "Big Spender",     desc: "Spend 300 coins in the shop",   type: "coinsSpent",   target: 300, reward: 180, difficulty: "medium" },
  { id: "earn_200",     emoji: "🪙", name: "Coin Farmer",     desc: "Earn 200 coins from rolls",     type: "coinsEarned",  target: 200, reward: 150, difficulty: "medium" },
  { id: "get_epic",     emoji: "💜", name: "Epic Hunter",     desc: "Pull an Epic or better",        type: "minRarity",    target: "Epic",  reward: 300, difficulty: "hard"   },
  { id: "roll_50",      emoji: "🎲", name: "Dedicated",       desc: "Roll 50 times today",           type: "rolls",        target: 50,  reward: 350, difficulty: "hard"   },
  { id: "get_5_new",    emoji: "🗂️", name: "Hamster Haul",    desc: "Add 5 new hamsters today",      type: "newHamsters",  target: 5,   reward: 400, difficulty: "hard"   },
  { id: "earn_500",     emoji: "🪙", name: "Gold Rush",       desc: "Earn 500 coins from rolls",     type: "coinsEarned",  target: 500, reward: 400, difficulty: "hard"   },
];

// ─── WEEKLY CHALLENGE POOL ────────────────────────────────────
export const WEEKLY_POOL = [
  { id: "w_roll_500",      emoji: "🎲", name: "Roll Marathon",     desc: "Roll 500 times this week",            type: "rolls",       target: 500,  reward: 2500 },
  { id: "w_earn_5000",     emoji: "🪙", name: "Weekly Wages",      desc: "Earn 5,000 coins from rolls",         type: "coinsEarned", target: 5000, reward: 2000 },
  { id: "w_get_15_new",    emoji: "🐹", name: "Collector's Week",  desc: "Add 15 new hamsters this week",       type: "newHamsters", target: 15,   reward: 3000 },
  { id: "w_spend_2000",    emoji: "🛍️", name: "High Roller Week",  desc: "Spend 2,000 coins in the shop",       type: "coinsSpent",  target: 2000, reward: 2200 },
  { id: "w_get_legendary", emoji: "🧡", name: "Legend Seeker",     desc: "Pull a Legendary or better",          type: "minRarity",   target: "Legendary", reward: 3500 },
  { id: "w_roll_250",      emoji: "🎲", name: "Century Roll",      desc: "Roll 250 times this week",            type: "rolls",       target: 250,  reward: 1800 },
  { id: "w_win_5_battles", emoji: "⚔️", name: "Battle Week",       desc: "Win 5 Top Trumps battles this week",  type: "battleWins",  target: 5,    reward: 2800 },
  { id: "w_earn_10000",    emoji: "💰", name: "Coin Hoarder Week", desc: "Earn 10,000 coins from rolls",        type: "coinsEarned", target: 10000,reward: 5000 },
];

const RARITY_ORDER       = ["Common","Uncommon","Rare","Epic","Legendary","Mythic","Ultra"];
const DIFFICULTY_COLOURS = { easy: "#4caf50", medium: "#ff9800", hard: "#e91e63" };
const WEEKLY_COLOUR      = "#00e5ff";

// ─── HELPERS ─────────────────────────────────────────────────
function getTodayKey() { return new Date().toDateString(); }

function getWeekKey() {
  const now = new Date();
  const day = now.getDay();
  const diff = (day === 0 ? -6 : 1) - day;
  const mon  = new Date(now); mon.setDate(now.getDate() + diff);
  return "week_" + mon.toDateString();
}

function seededHash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = ((h << 5) - h) + str.charCodeAt(i);
  return Math.abs(h);
}

function pickDailyMissions() {
  const hash   = seededHash(new Date().toDateString());
  const easy   = MISSION_POOL.filter(m => m.difficulty === "easy");
  const medium = MISSION_POOL.filter(m => m.difficulty === "medium");
  const hard   = MISSION_POOL.filter(m => m.difficulty === "hard");
  return [easy[hash % easy.length], medium[(hash*3) % medium.length], hard[(hash*7+2) % hard.length]];
}

function pickWeeklyChallenge() {
  const hash = seededHash(getWeekKey());
  return WEEKLY_POOL[hash % WEEKLY_POOL.length];
}

export function getTodaysMissions()  { return pickDailyMissions(); }
export function getWeeklyChallenge() { return pickWeeklyChallenge(); }

export function loadMissionProgress() {
  const saved = JSON.parse(localStorage.getItem("missionProgress") || "{}");
  if (saved.date !== getTodayKey()) return { date: getTodayKey(), progress: {}, claimed: {} };
  // Guarantee shape even if loaded from old localStorage without claimed
  return { progress: {}, claimed: {}, ...saved };
}
export function saveMissionProgress(data) { localStorage.setItem("missionProgress", JSON.stringify(data)); }

export function updateMissionProgress(type, value) {
  const data = loadMissionProgress();
  data.progress[type] = (data.progress[type] || 0) + value;
  saveMissionProgress(data);
  updateWeeklyProgress(type, value);
  return data;
}

export function loadWeeklyProgress() {
  const saved = JSON.parse(localStorage.getItem("weeklyProgress") || "{}");
  if (saved.week !== getWeekKey()) return { week: getWeekKey(), progress: {}, claimed: false };
  return { progress: {}, claimed: false, ...saved };
}
export function saveWeeklyProgress(data) { localStorage.setItem("weeklyProgress", JSON.stringify(data)); }

export function updateWeeklyProgress(type, value) {
  const data = loadWeeklyProgress();
  data.progress[type] = (data.progress[type] || 0) + value;
  saveWeeklyProgress(data);
  return data;
}

export function checkMissionComplete(mission, progress) {
  if (mission.type === "minRarity") {
    return !!(progress.highestRarity && RARITY_ORDER.indexOf(progress.highestRarity) >= RARITY_ORDER.indexOf(mission.target));
  }
  if (mission.type === "newHamsters") return (progress.newHamsters || 0) >= mission.target;
  return (progress[mission.type] || 0) >= mission.target;
}

// ─── COMPONENT ───────────────────────────────────────────────
export default function Missions({ missionProgress, onClaim, onWeeklyClaim, onClose }) {
  const [tab, setTab] = useState("daily");
  const [weeklyData, setWeeklyData] = useState(() => loadWeeklyProgress());

  // Re-read weekly progress whenever missionProgress changes (rolls, shop purchases, etc.)
  // since updateMissionProgress also calls updateWeeklyProgress
  React.useEffect(() => {
    setWeeklyData(loadWeeklyProgress());
  }, [missionProgress]);

  const handleTabChange = (t) => {
    if (t === "weekly") setWeeklyData(loadWeeklyProgress());
    setTab(t);
  };

  const missions       = getTodaysMissions();
  const { progress, claimed } = missionProgress;
  const weekly         = pickWeeklyChallenge();
  const weeklyProgress = weeklyData.progress;
  const weeklyClaimed  = weeklyData.claimed;
  const weeklyDone     = (() => {
    if (weekly.type === "minRarity") return !!(weeklyProgress.highestRarity && RARITY_ORDER.indexOf(weeklyProgress.highestRarity) >= RARITY_ORDER.indexOf(weekly.target));
    return (weeklyProgress[weekly.type] || 0) >= weekly.target;
  })();

  const now      = new Date();
  const midnight = new Date(now); midnight.setHours(24,0,0,0);
  const msLeft   = midnight - now;
  const hLeft    = Math.floor(msLeft/3600000);
  const mLeft    = Math.floor((msLeft%3600000)/60000);
  const dailyRefresh  = hLeft > 0 ? `${hLeft}h ${mLeft}m` : `${mLeft}m`;
  const daysToMon = now.getDay() === 0 ? 1 : 8 - now.getDay();
  const weeklyRefresh = `${daysToMon}d ${hLeft}h`;

  const totalPossible = missions.reduce((s,m) => s+m.reward, 0);
  const totalClaimed  = missions.filter(m => claimed[m.id]).reduce((s,m) => s+m.reward, 0);

  return (
    <div className="modal-overlay" onClick={() => { playCloseSound(); onClose(); }}>
      <div className="modal-box missions-box" onClick={e => e.stopPropagation()}>
        <h2 style={{ marginBottom: 4, textAlign: "center" }}>📋 Missions</h2>

        <div className="missions-tabs">
          <button className={`missions-tab${tab==="daily"?" active":""}`} onClick={() => handleTabChange("daily")}>Daily</button>
          <button className={`missions-tab${tab==="weekly"?" active":""}${weeklyDone&&!weeklyClaimed?" has-reward":""}`} onClick={() => handleTabChange("weekly")}>
            Weekly {weeklyDone&&!weeklyClaimed?"🔥":""}
          </button>
        </div>

        {tab === "daily" && (<>
          <p className="missions-subtitle">3 missions · resets at midnight</p>
          <p className="missions-refresh">Refreshes in <span>{dailyRefresh}</span></p>
          {missions.map(mission => {
            const isClaimed  = !!claimed[mission.id];
            const isComplete = checkMissionComplete(mission, progress);
            const colour     = DIFFICULTY_COLOURS[mission.difficulty];
            let current = 0, total = mission.target;
            if (mission.type === "minRarity") {
              current = progress.highestRarity ? RARITY_ORDER.indexOf(progress.highestRarity)+1 : 0;
              total   = RARITY_ORDER.indexOf(mission.target)+1;
            } else if (mission.type === "newHamsters") {
              current = progress.newHamsters || 0;
            } else { current = progress[mission.type] || 0; }
            const pct = Math.min((current/total)*100, 100);
            return (
              <div key={mission.id} className={`mission-card${isComplete&&!isClaimed?" completed":""}${isClaimed?" claimed":""}`}>
                <div className="mission-top">
                  <div className="mission-left">
                    <div className="mission-emoji">{mission.emoji}</div>
                    <div className="mission-info">
                      <div className="mission-name">{mission.name}</div>
                      <div className="mission-desc">{mission.desc}</div>
                    </div>
                  </div>
                  <div className="mission-reward">🪙 {mission.reward}</div>
                </div>
                <div className="mission-progress-row">
                  <div className="mission-progress-bar">
                    <div className="mission-progress-fill" style={{width:`${pct}%`,background:isClaimed?"#666":colour,boxShadow:isClaimed?"none":`0 0 8px ${colour}88`}}/>
                  </div>
                  <div className="mission-progress-count" style={{color:isClaimed?"var(--text-muted)":colour}}>
                    {mission.type==="minRarity"?(isComplete||isClaimed?"✓":progress.highestRarity||"—"):`${Math.min(current,total)}/${total}`}
                  </div>
                </div>
                {isComplete&&!isClaimed&&<button className="mission-claim-btn" onClick={()=>{playClaimSound();onClaim(mission);}}>Claim 🪙 {mission.reward} coins</button>}
                {isClaimed&&<div className="mission-claimed-label">✓ Claimed</div>}
              </div>
            );
          })}
          <div className="missions-total">
            <span className="missions-total-label">Today's earnings</span>
            <span className="missions-total-coins">🪙 {totalClaimed} / {totalPossible}</span>
          </div>
        </>)}

        {tab === "weekly" && (() => {
          let current = 0, total = weekly.target;
          if (weekly.type === "minRarity") {
            current = weeklyProgress.highestRarity ? RARITY_ORDER.indexOf(weeklyProgress.highestRarity)+1 : 0;
            total   = RARITY_ORDER.indexOf(weekly.target)+1;
          } else { current = weeklyProgress[weekly.type] || 0; }
          const pct = Math.min((current/total)*100, 100);
          return (<>
            <p className="missions-subtitle">1 big challenge · resets Monday</p>
            <p className="missions-refresh">Resets in <span>{weeklyRefresh}</span></p>
            <div className={`mission-card mission-weekly${weeklyDone&&!weeklyClaimed?" completed":""}${weeklyClaimed?" claimed":""}`}>
              <div className="mission-weekly-badge">WEEKLY</div>
              <div className="mission-top">
                <div className="mission-left">
                  <div className="mission-emoji" style={{fontSize:"2rem"}}>{weekly.emoji}</div>
                  <div className="mission-info">
                    <div className="mission-name" style={{fontSize:"1.05rem"}}>{weekly.name}</div>
                    <div className="mission-desc">{weekly.desc}</div>
                  </div>
                </div>
                <div className="mission-reward" style={{color:WEEKLY_COLOUR,fontSize:"1.1rem"}}>🪙 {weekly.reward.toLocaleString()}</div>
              </div>
              <div className="mission-progress-row">
                <div className="mission-progress-bar">
                  <div className="mission-progress-fill" style={{width:`${pct}%`,background:weeklyClaimed?"#666":`linear-gradient(90deg,${WEEKLY_COLOUR},#bf5fff)`,boxShadow:weeklyClaimed?"none":`0 0 10px ${WEEKLY_COLOUR}88`}}/>
                </div>
                <div className="mission-progress-count" style={{color:weeklyClaimed?"var(--text-muted)":WEEKLY_COLOUR}}>
                  {weekly.type==="minRarity"?(weeklyDone||weeklyClaimed?"✓":weeklyProgress.highestRarity||"—"):`${Math.min(current,total).toLocaleString()}/${total.toLocaleString()}`}
                </div>
              </div>
              {weeklyDone&&!weeklyClaimed&&<button className="mission-claim-btn mission-claim-weekly" onClick={()=>{playClaimSound();onWeeklyClaim(weekly);setWeeklyData(loadWeeklyProgress());}}>🎉 Claim 🪙 {weekly.reward.toLocaleString()} coins!</button>}
              {weeklyClaimed&&<div className="mission-claimed-label">✓ Claimed this week</div>}
            </div>
            <p className="missions-weekly-hint">New challenge every Monday. Progress carries across days within the week.</p>
          </>);
        })()}

        <button className="back-button" onClick={() => { playCloseSound(); onClose(); }} style={{ marginTop: 16, width: "100%" }}>Close</button>
      </div>
    </div>
  );
}